import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { useAuth } from "./auth";

const DataCtx = createContext(null);

export function DataProvider({ children }) {
  const { user } = useAuth();
  const [spaces, setSpaces] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) return;
    const [s, i] = await Promise.all([api.get("/spaces"), api.get("/items")]);
    setSpaces(s.data);
    setItems(i.data);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    if (user) { setLoading(true); refresh(); }
    else { setSpaces([]); setItems([]); setLoading(false); }
  }, [user, refresh]);

  const updateItem = async (id, patch) => {
    // optimistic
    setItems((prev) => prev.map((it) => (it.id === id ? { ...it, ...patch } : it)));
    try {
      const r = await api.patch(`/items/${id}`, patch);
      setItems((prev) => prev.map((it) => (it.id === id ? r.data : it)));
    } catch {
      await refresh();
    }
  };

  const addItem = (item) => setItems((prev) => [item, ...prev]);

  const deleteItem = async (id) => {
    setItems((prev) => prev.filter((it) => it.id !== id));
    await api.delete(`/items/${id}`);
  };

  return (
    <DataCtx.Provider value={{ spaces, items, loading, refresh, updateItem, addItem, deleteItem }}>
      {children}
    </DataCtx.Provider>
  );
}

export const useData = () => useContext(DataCtx);
